import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SiteFooter from '../SiteFooter'; // Import SiteFooter

const Fuzou = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-amber-50 flex flex-col">
      {/* Main Content Area with flex-grow to push footer down */}
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-2xl">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-amber-800 mb-6 hover:text-amber-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回
          </button>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-amber-200 text-center">
              
            <h2 className="text-3xl font-bold text-amber-900 mb-8 font-serif tracking-widest">
               护 身 咒
            </h2>

            <p className="text-gray-600 mb-8 italic">
                不顺时，身体不好时，大声的说出来
            </p>

            <div className="space-y-4 text-xl sm:text-2xl font-medium text-gray-800 leading-relaxed font-serif">
              <p>天罗神、地罗神，</p>
              <p>天兵天将护我身，</p>
              <p>铁人铁马铁将军，</p>
              <p>十二护法护我身，</p>
              <p>四大护法前面走，</p>
              <p>八大金刚护我身，</p>
              <p>跟我走来护我身，</p>
              <p>一切灾殃化为尘。</p>
            </div>

            <div className="mt-10 pt-6 border-t border-amber-100">
               <span className="text-amber-800 text-sm">此为民间流传之金光护身法咒，诚心念诵可增福慧，化险为夷。</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* SiteFooter placed at the bottom */}
      <SiteFooter />
    </div>
  );
};

export default Fuzou;